var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    fillRule: "evenodd",
    d: "M20 7h66c5.51915024 0 10 4.48084976 10 10v66c0 5.51915024-4.48084976 10-10 10H20c-5.51915024 0-10-4.48084976-10-10V17c0-5.51915024 4.48084976-10 10-10z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    width: "200%",
    height: "200%",
    x: "-50%",
    y: "-50%",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 8,
    in: "SourceAlpha",
    result: "shadow-1-feOffset-shadow"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadow-1-feOffset-shadow",
    result: "shadow-1-feGaussianBlur-shadow",
    stdDeviation: 9.036
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadow-1-feGaussianBlur-shadow",
    result: "shadow-1-feColorMatrix-shadow",
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.12 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    stroke: "black",
    strokeOpacity: 0,
    strokeWidth: 0,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "rgb(2,88,127)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M56.77804565 34.97595215c-.83728027.02172851-1.56298828.60058594-1.78961181 1.42749023l-7.6355896 26.10180664c-.30200195 1.03613282.2722168 2.12719727 1.28253174 2.43688965s2.07418823-.2791748 2.37619018-1.31530762l7.6355896-26.10180664c.18664551-.6036377.07711792-1.26245117-.29397583-1.76855468-.37109375-.50610352-.95791626-.796875-1.57513428-.78051758zm3.33642579 3.23010254c.26348877-.70605469.89974975-1.19348145 1.63464355-1.25219727.58416748-.0444336 1.15594482.18859863 1.55096436.63220215l10.18078613 11.09326172c.68435669.75219726.68435669 1.91918945 0 2.67138672L63.30007935 62.44396973c-.45410157.55566406-1.1704712.80847168-1.86184693.65710449-.69134521-.15136719-1.24453735-.68225098-1.43771362-1.37963867-.19317627-.69750977.00527954-1.44726563.51574707-1.94885254l8.94796753-9.74731446-8.94796753-9.76782226c-.5088501-.54699707-.66525269-1.34545899-.40179443-2.0513916zm-16.1220398-1.25219727c-.49450684.03076172-.9579773.2574463-1.2925415.63220215L32.519104 48.67932129c-.68432617.75219726-.68432617 1.91918945 0 2.67138672L42.69989014 62.4440918c.45413208.55554199 1.1705017.8083496 1.86184692.65698242.69137573-.15136719 1.24453735-.68225098 1.43774414-1.37963867.19317627-.6973877-.00527954-1.44726563-.51577759-1.94873047l-8.947937-9.74743653 8.947937-9.76782226c.53936768-.58203125.67758179-1.44274902.34866333-2.17138672-.32891845-.72851562-1.05828857-1.17736816-1.8399353-1.13220215z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeIcon);
export default __webpack_public_path__ + "static/media/code-icon.024f7c6d43c2a8bc45a4ba5402b0b9fe.svg";
export { ForwardRef as ReactComponent };